export default __webpack_public_path__ + "static/media/notifications_12.dc5a701c.png";